module.exports = __webpack_public_path__ + "assets/img/1dd7-ml.svg";